import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BannerService } from '../../banner.service';

@Component({
  selector: 'app-blog-details',
  templateUrl: './blog-details.component.html',
  styleUrls: ['./blog-details.component.scss']
})
export class BlogDetailsComponent implements OnInit {
  id: any;
  blogs: any;

  constructor(private router: ActivatedRoute, private bannerservice: BannerService,) {
    this.id = this.router.snapshot.params.id
    console.log(this.id);
  }

  ngOnInit(): void {
    this.getblogs();
  }


  getblogs() {
    this.bannerservice.getblogs().subscribe((res: any) => {
      console.log(res);
      this.blogs = res.data.filter((data: any) => data.id == this.id);
      console.log(this.blogs);

    })
  }
}
